import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import ErrorScreen from "./ErrorScreen";

export default function RouterErrorBoundary() {
  const error = useRouteError();

  console.error("Router error:", error);

  let title = "Ha ocurrido un error";
  let description = "No se ha podido cargar esta pantalla.";

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      title = "Página no encontrada";
      description = "La ruta a la que intentas acceder no existe.";
    } else if (error.status === 401) {
      title = "No autorizado";
      description = "No tienes permisos para acceder a esta página.";
    } else {
      title = `Error ${error.status}`;
      description = error.statusText || description;
    }
  }

  return <ErrorScreen title={title} description={description} />;
}
